import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { bonusValueRows } from '../data/bonuses';
import { bonusValue, fullPrice, included, price, volumesValue } from '../data/copy';
export function OfferSection() {
  return <section id="oferta" className="defer-paint w-full scroll-mt-6 bg-ink py-12 sm:py-16" aria-labelledby="offer-heading" data-id="element-107" data-mp="def0n3rwzhwa">
      <div className="mx-auto max-w-5xl px-6" data-id="element-108" data-mp="icot36m984e7">
        <div className="mx-auto max-w-2xl text-center" data-id="element-109" data-mp="mejsg5kmk7pc">
          <p className="eyebrow text-gold" data-id="element-110" data-mp="md0c6eyyxwnk">Tu acceso completo hoy</p>
          <h2 id="offer-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.1] text-ivory sm:text-4xl" data-id="element-111" data-mp="rey37vdm1vr2">
            Megapack Atletismo 360
          </h2>
          <p className="mt-3 font-sans text-base leading-relaxed text-stone" data-id="element-112" data-mp="2t5jbd6a8vzv9">
            Sistema completo: 6 volúmenes + 70 sesiones + 5 bonos.
          </p>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-[1fr_1.1fr] lg:gap-8" data-id="element-113" data-mp="2y6gtjiv98twr">
          <div className="space-y-6" data-id="element-114" data-mp="12p35t5e9pkop">
            <div className="rounded-3xl border border-line bg-coal p-6 sm:p-7" data-id="element-115" data-mp="xws7u83388ys">
              <p className="eyebrow text-stone" data-id="element-116" data-mp="xupa11vp1bji">Lo que vale por separado</p>
              <ul className="mt-5 divide-y divide-line" data-id="element-117" data-mp="sy8hlvhgob0m">
                <li className="flex items-baseline justify-between gap-4 py-2.5 font-sans text-[0.85rem] text-ivory/85" data-id="element-118" data-mp="own9sojsamxa">
                  <span data-id="element-119" data-mp="1llbfqmi86jqc">6 volúmenes técnicos (+70 sesiones)</span>
                  <span className="shrink-0 text-stone" data-id="element-120" data-mp="1gnjdoznv9h8f">{volumesValue}</span>
                </li>
                {bonusValueRows.map(row => <li key={row.label} className="flex items-baseline justify-between gap-4 py-2.5 font-sans text-[0.85rem] text-ivory/85" data-id="element-121" data-mp="1ckwpd8qemefz">
                    <span data-id="element-122" data-mp="17opjth1x74yk">{row.label}</span>
                    <span className="shrink-0 text-stone" data-id="element-123" data-mp="172fxam3e598">{row.value}</span>
                  </li>)}
              </ul>
              <div className="mt-4 flex items-baseline justify-between gap-4 border-t border-gold/30 pt-4" data-id="element-124" data-mp="3sbspxr3zy57g">
                <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-125" data-mp="3tvawoazb9qgd">
                  Valor total del sistema
                </span>
                <span className="font-display text-3xl font-bold leading-none text-gold" data-id="element-126" data-mp="3ktuli10o9kb3">
                  {fullPrice}
                </span>
              </div>
              <p className="mt-4 font-sans text-[0.82rem] leading-relaxed text-stone" data-id="element-127" data-mp="3owr8e3x8w2ku">
                Los 5 bonos ({bonusValue}) van incluidos hoy sin costo
                adicional.
              </p>
            </div>

            <CountdownTimer data-id="element-128" data-mp="315lsjorb1aaj" />
          </div>

          <div className="rounded-3xl border border-gold/40 bg-coal p-6 text-center shadow-lift sm:p-9" data-id="element-129" data-mp="316n7w5fcsiy2">
            <p className="font-sans text-sm text-stone" data-id="element-130" data-mp="364yco1qsk39f">
              Valor normal:{' '}
              <span className="line-through" data-id="element-131" data-mp="2s5yth9m1sgkn">{fullPrice}</span>
            </p>
            <p className="mt-2 flex items-start justify-center gap-1 font-display font-bold leading-none text-ivory" data-id="element-132" data-mp="2x409tms3a1sf">
              <span className="mt-3 text-2xl text-gold" data-id="element-133" data-mp="2diqavnqet8yn">$</span>
              <span className="text-[5rem] leading-none sm:text-[6rem]" data-id="element-134" data-mp="28jdn90rprxv0">19</span>
            </p>
            <p className="mt-2 font-sans text-xs uppercase tracking-[0.16em] text-stone" data-id="element-135" data-mp="2mid9y2vo22oj">
              Un solo pago · en tu moneda local
            </p>

            <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-line pt-6 text-left sm:gap-x-6" data-id="element-136" data-mp="2ifqhbzr68dqa">
              {included.map(item => <li key={item} className="flex items-start gap-2 font-sans text-[0.8rem] leading-snug text-ivory/85 sm:text-[0.86rem]" data-id="element-137" data-mp="2rhzoqgr57qzg">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" strokeWidth={2.6} aria-hidden="true" data-id="element-138" data-mp="365b0ojr8ld03" />
                  {item}
                </li>)}
            </ul>

            <CtaButton size="large" className="mt-7 w-full" data-id="element-139" data-mp="3f6iyz1tr6du6">
              Acceso completo ahora — {price}
            </CtaButton>

            <p className="mt-4 text-center font-sans text-[11px] text-stone" data-id="element-140" data-mp="3a9sl8l5f7ubx">
              Pago seguro · acceso inmediato · garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}